export default __webpack_public_path__ + "static/media/main-stressometer-woman.78b7c57e.png";